import React from 'react';
import SolutionPageLayout from '../../components/SolutionPageLayout';
import CoManagedImage from '../../assets/generated-pages/co-managed-ai.png';

export default function CoManaged() {
  return (
    <SolutionPageLayout
      eyebrow="Co-Managed"
      title="Co-Managed Engagement"
      subtitle="Collaborate and innovate with shared expertise."
      description="The Co-Managed Engagement model brings your team and Vedalytics together as delivery partners. Responsibilities are shared, knowledge flows continuously, and both teams work side-by-side to move AI initiatives faster."
      image={CoManagedImage}
      stats={[
        { value: 'Shared', label: 'decision-making and delivery' },
        { value: 'Continuous', label: 'knowledge transfer' },
        { value: 'Joint', label: 'ownership of outcomes' },
        { value: 'Faster', label: 'collaboration cycles' },
      ]}
      highlights={[
        { icon: 'workflow', title: 'Balanced Responsibilities', text: 'Both teams contribute to planning, development, validation, and execution with clear ownership.' },
        { icon: 'layers', title: 'Continuous KT', text: 'Your team gains practical knowledge while working directly with Vedalytics specialists.' },
        { icon: 'analytics', title: 'Enhanced Efficiency', text: 'Combine domain context with AI delivery capability to reduce delays and improve execution quality.' },
      ]}
      overviewTitle="Best of both worlds"
      overviewText="Co-managed delivery is built for organizations that want strategic control and deep participation while still benefiting from Vedalytics’ AI, data, and engineering capabilities."
      overviewPoints={[
        'Shared roadmap, shared delivery rhythm, and transparent responsibilities.',
        'Hands-on collaboration between your domain experts and our technical team.',
        'Knowledge transfer embedded into the project instead of added at the end.',
        'Strong fit for teams modernizing platforms or building AI capability internally.',
      ]}
      workflowTitle="How co-managed delivery works"
      workflow={[
        { title: 'Define Scope', text: 'Together we define goals, roles, responsibilities, milestones, and communication cadence.' },
        { title: 'Build Together', text: 'Both teams contribute to development, data workflows, reviews, and solution design.' },
        { title: 'Transfer Knowledge', text: 'Vedalytics enables your team through documentation, walkthroughs, and shared execution.' },
        { title: 'Deploy & Optimize', text: 'Solutions are launched collaboratively and improved through continuous feedback.' },
      ]}
      outcomesTitle="What shared delivery creates"
      outcomes={[
        'Faster execution with stronger internal alignment.',
        'Higher team confidence through continuous knowledge transfer.',
        'Clear ownership across business, data, and engineering workstreams.',
        'Improved long-term maintainability after deployment.',
      ]}
    />
  );
}
